import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT } from "../colors";

const LOCATIONS = [
  { name: "Downtown Bistro", reviews: 142, rating: 4.8 },
  { name: "Riverside Café", reviews: 89, rating: 4.6 },
  { name: "Airport Express", reviews: 213, rating: 4.3 },
  { name: "Mall Food Court", reviews: 67, rating: 4.9 },
];

export const MultiLocationAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const headerAppear = spring({ frame, fps, config: { damping: 14 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        padding: 36,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 560,
        }}
      >
        {/* Header */}
        <div
          style={{
            opacity: headerAppear,
            transform: `translateY(${interpolate(headerAppear, [0, 1], [10, 0])}px)`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div style={{ fontSize: 22, fontWeight: 700, color: GRAY[800] }}>Your Locations</div>
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: BRAND[600],
              backgroundColor: BRAND[50],
              padding: "6px 14px",
              borderRadius: 14,
            }}
          >
            4 connected
          </div>
        </div>

        {/* Location cards */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {LOCATIONS.map((loc, i) => {
            const cardSpring = spring({
              frame: frame - 15 - i * 12,
              fps,
              config: { damping: 13 },
            });
            return (
              <div
                key={loc.name}
                style={{
                  opacity: cardSpring,
                  transform: `translateX(${interpolate(cardSpring, [0, 1], [30, 0])}px)`,
                  backgroundColor: "white",
                  borderRadius: 14,
                  padding: "16px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  border: `1px solid ${GRAY[200]}`,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 42,
                      height: 42,
                      borderRadius: 10,
                      background: `linear-gradient(135deg, ${BRAND[100]}, ${BRAND[200]})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 20,
                    }}
                  >
                    📍
                  </div>
                  <div>
                    <div style={{ fontSize: 18, fontWeight: 600, color: GRAY[800] }}>
                      {loc.name}
                    </div>
                    <div style={{ fontSize: 15, color: GRAY[400] }}>
                      {loc.reviews} reviews · ⭐ {loc.rating}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontSize: 14,
                    fontWeight: 600,
                    color: ACCENT[600],
                    backgroundColor: ACCENT[100],
                    padding: "5px 12px",
                    borderRadius: 12,
                  }}
                >
                  <div
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: ACCENT[500],
                    }}
                  />
                  Active
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </AbsoluteFill>
  );
};
